// extracted by mini-css-extract-plugin
export var disabled = "_g-a";
export var hierarchyLinkGray = "_g-4";
export var hierarchyLinkUnderline = "_g-3";
export var hierarchyPrimary = "_g-0";
export var hierarchySecondary = "_g-1";
export var hierarchyTertiary = "_g-2";
export var pressed = "_g-6";
export var themeAction = "_g-5";
export var themeDestructive = "_g-8";
export var themeNormal = "_g-7";
export var themeSuccess = "_g-9";